import React from 'react';
import TeacherMasterLayout from '../../../layouts/gcstaff/staffmasterlayout/TeacherMasterLayout';
import LibraroPage from '../../../subsreens/gcstaff/aiassistant/LibraroPage';



const StaffAIAssistant = () => {
    return(
       <TeacherMasterLayout>
       <LibraroPage></LibraroPage>
       </TeacherMasterLayout>
    )
}

export default StaffAIAssistant;